// Readoo shared helpers: category colors, slugs, dates, zodiac.

export const CATEGORY_COLOR = {
  "Politica": "#e11d48",
  "Cronaca": "#ef4444",
  "Attualità": "#3b82f6",
  "Economia": "#10b981",
  "Sport": "#f59e0b",
  "Calcio": "#16a34a",
  "Meteo": "#0ea5e9",
  "Locale": "#14b8a6",
  "Tecnologia": "#6366f1",
  "Spettacoli": "#ec4899",
  "Cultura": "#a855f7",
  "Salute": "#14b8a6",
  "Lifestyle": "#f472b6",
  "Oroscopo": "#8b5cf6",
  "Viaggi": "#0ea5e9",
  "Food": "#84cc16",
  "Motori": "#334155",
  "4 Zampe": "#c2410c",
  "Ultimissime": "#e86a4c",
};

export const BRAND = "#E86A4C";

export function catColor(cat) {
  return CATEGORY_COLOR[cat] || BRAND;
}

export function slugify(str = "") {
  return String(str)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "") || "articolo";
}

// Alias di visualizzazione categoria: il backend usa la chiave, UI/URL usano il valore.
export const CATEGORY_LABEL = { "Spettacoli": "Spettacolo" };
export const displayCat = (name = "") => CATEGORY_LABEL[name] || name;

export function categorySlug(cat = "") {
  return slugify(displayCat(cat));
}

// Resolve a slug back to the real category name from a known list.
export function categoryFromSlug(slug, categories = []) {
  return categories.find((c) => categorySlug(c) === slug) || null;
}

// Gli articoli Sport di calcio vivono nella categoria virtuale Calcio.
export const articleCat = (a) => (a?.calcio && a.category === "Sport" ? "Calcio" : a?.category);

export function articlePath(a) {
  if (!a) return "/";
  return `/${categorySlug(articleCat(a))}/${slugify(a.title)}`;
}

const MONTHS_IT_SHORT = ["gen","feb","mar","apr","mag","giu","lug","ago","set","ott","nov","dic"];

export function formatRelativeDate(input) {
  if (!input) return "";
  const d = new Date(input);
  if (isNaN(d.getTime())) return "";
  const now = new Date();
  let diffMs = now.getTime() - d.getTime();
  if (diffMs < 0) diffMs = 0;  // timestamp nel futuro (skew/fuso orario) => "adesso"
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return "adesso";
  if (minutes < 60) return `${minutes} min fa`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} ${hours === 1 ? "ora" : "ore"} fa`;
  return absoluteDate(d);  // oltre 24 ore => data
}

function absoluteDate(d) {
  const day = d.getDate();
  const mon = MONTHS_IT_SHORT[d.getMonth()] || "";
  const year = d.getFullYear();
  const now = new Date();
  if (year === now.getFullYear()) return `${day} ${mon}`;
  return `${day} ${mon} ${year}`;
}

export function readingMinutes(content = "") {
  const words = (content || "").split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

export const ZODIAC_SIGNS = [
  { key: "ariete", name: "Ariete", emoji: "♈", dates: "21 mar - 19 apr" },
  { key: "toro", name: "Toro", emoji: "♉", dates: "20 apr - 20 mag" },
  { key: "gemelli", name: "Gemelli", emoji: "♊", dates: "21 mag - 20 giu" },
  { key: "cancro", name: "Cancro", emoji: "♋", dates: "21 giu - 22 lug" },
  { key: "leone", name: "Leone", emoji: "♌", dates: "23 lug - 22 ago" },
  { key: "vergine", name: "Vergine", emoji: "♍", dates: "23 ago - 22 set" },
  { key: "bilancia", name: "Bilancia", emoji: "♎", dates: "23 set - 22 ott" },
  { key: "scorpione", name: "Scorpione", emoji: "♏", dates: "23 ott - 21 nov" },
  { key: "sagittario", name: "Sagittario", emoji: "♐", dates: "22 nov - 21 dic" },
  { key: "capricorno", name: "Capricorno", emoji: "♑", dates: "22 dic - 19 gen" },
  { key: "acquario", name: "Acquario", emoji: "♒", dates: "20 gen - 18 feb" },
  { key: "pesci", name: "Pesci", emoji: "♓", dates: "19 feb - 20 mar" },
];

export const ZODIAC_KEY = "readoo_my_sign";
export const readMySign = () => { try { return localStorage.getItem(ZODIAC_KEY) || null; } catch { return null; } };
export const writeMySign = (k) => { try { k ? localStorage.setItem(ZODIAC_KEY, k) : localStorage.removeItem(ZODIAC_KEY); } catch {} };

export function stars(n = 0) {
  const full = Math.max(0, Math.min(5, Math.round(n)));
  return "★".repeat(full) + "☆".repeat(5 - full);
}
